import React, { useState } from "react";
import { Popup } from "components/basic/Popup";

interface Props {
  ID: string;
  onConfirm: (ID: string) => Promise<void>;
}

const RemoveComponentButton: React.FC<Props> = ({ onConfirm: removeComponent, ID }) => {
  const [loading, setLoading] = useState(false);
  return (
    <Popup
      mt={-60}
      content={(closeDeletePopup) => {
        return (
          <div className="text-xs px-2 py-2 border border-gray-200 rounded">
            <div className="font-medium">Delete component?</div>
            <div className="italic mb-2">
              This is a destructive event that can't be undone!
            </div>
            <div className="flex">
              <div className="w-1/2 pr-1">
                <button
                  className={`${tw.smallBtn} border-red-400 bg-red-400 text-white w-full ${
                    loading ? "opacity-50" : ""
                  }`}
                  onClick={() => {
                    if (!loading) {
                      setLoading(true);
                      removeComponent(ID)
                        .then(() => {})
                        .catch(() => setLoading(false));
                      closeDeletePopup();
                    }
                  }}
                >
                  Delete
                </button>
              </div>
              <div className="w-1/2 pl-1">
                <button
                  className={`${tw.smallBtn} w-full`}
                  onClick={() => {
                    closeDeletePopup();
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        );
      }}
    >
      <button className={`${tw.popupBtn} text-red-500`}>Delete component</button>
    </Popup>
  );
};

export default RemoveComponentButton;

const tw = {
  smallBtn:
    "bg-white py-1 px-2 shadow rounded border border-gray-200 focus:outline-none text-xs hover:font-medium",
  popupBtn: "py-1 w-full font-medium text-gray-700 focus:outline-none hover:bg-gray-200",
};
